export const UseGetComponentImport = (componentName: string) => {
  return (componentType: string) => () =>
    import(`~/components/cms/custom/${componentName}/${componentName}${componentType}`);
};
